import { FC, useEffect, useState } from "react"
import File1 from "../../assets/ToDesigners/File1";
import File2 from "../../assets/ToDesigners/File2";
import File3 from "../../assets/ToDesigners/File3";
import Arrow from "../../assets/ToDesigners/Arrow";
import { Link } from 'react-router-dom';
import { scrollTo } from "../../helpers";
import Download from "../../assets/ToDesigners/Download"
const ToDesigners: FC = () => {
  const [isBimModelsOpen, setIsBimModelsOpen] = useState<boolean>(false);

  const [isLesFilesOpen, setIsLesFilesOpen] = useState<boolean>(false);
  const [isTechDocs, setIsTechDocs] = useState<boolean>(false);
  const [lesLink, setLesLink] = useState<string | null>(null);
  const [revitLink, setRevitLink] = useState<string | null>(null);
  const [nanoCadLink, setNanoCadLink] = useState<string | null>(null);
  const getLesFiles = async (): Promise<void> => {
    const resp = await fetch('https://django.skatled.ru/api/v1/files?section=Les');
    const lesFiles = await resp.json();
    if (lesFiles[0]?.url !== undefined) {
      setLesLink(lesFiles[0]?.url);
    } else {
      setLesLink(null)
    }
  }
  const getRevitFiles = async (): Promise<void> => {
    const resp = await fetch('https://django.skatled.ru/api/v1/files?section=Revit');
    const revitFiles = await resp.json();
    if (revitFiles[0]?.url !== undefined) {
      setRevitLink(revitFiles[0]?.url);
    } else {
      setRevitLink(null)
    }
  }

  const getNanoCadFiles = async (): Promise<void> => {
    const resp = await fetch('https://django.skatled.ru/api/v1/files?section=nanoCad');
    const nanoCadFiles = await resp.json();
    if (nanoCadFiles[0]?.url !== undefined) {
      setNanoCadLink(nanoCadFiles[0]?.url);
    } else {
      setNanoCadLink(null)
    }
  }

  useEffect(() => {
    getLesFiles();
    getRevitFiles();
    getNanoCadFiles();
  },[])

  return <div className='to-designers container-fluid' id='to-designers'>
    <div className="row to-designers__buttons">
      <div className="buttons">
        <button onClick={() => scrollTo('why-matters')}>Полезная информация</button>
        <button onClick={() => scrollTo('order')}>Светорасчет</button>
        <button onClick={() => scrollTo('why-us')}>Наши преимущества</button>
        <button onClick={() => scrollTo('bonuses')}>Бонусы</button>
        <button onClick={() => scrollTo('completed-projects')}>Проекты</button>
      </div>
    </div>
    <div className="row to-designers__title">
      <h1>Проектировщикам</h1>
    </div>
    <div className="row to-designers__files">
      <div className="files-title col-12">
        <h2>Мы рассчитываем на долгосрочное и продуктивное сотрудничество,
          поэтому подготовили для вас все необходимые материалы в этом разделе.</h2>
      </div>
      <div className="files col-lg-12 col-7">
        <div className='file-wrapper col-lg-3'>
          <div className="file-wrapper__file les-files">
            <File1 />
          </div>
          <div className="file-wrapper__title">
            <h3>IES-файлы</h3>
            <div className="title-select">
              <div className={isLesFilesOpen ? 'select-arrow-open' : 'select-arrow-close'} onClick={() => setIsLesFilesOpen(!isLesFilesOpen)}>
                <Arrow />
              </div>
              {isLesFilesOpen && (
                <div className='select-options'>
                  <a rel='noreferrer' target="_blank" href={lesLink as string} className='option'>
                    <Download />IES-файлы
                  </a>
                </div>
              )}
            </div>
          </div>
        </div>
        <div className='file-wrapper col-lg-3'>
          <div className="file-wrapper__file bim-models">
            <File2 />
          </div>
          <div className="file-wrapper__title">
            <h3>BIM-модели</h3>
            <div className="title-select">
              <div className={isBimModelsOpen ? 'select-arrow-open' : 'select-arrow-close'} onClick={() => setIsBimModelsOpen(!isBimModelsOpen)}>
                <Arrow />
              </div>
              {isBimModelsOpen && (
                <div className='select-options'>
                  <a href={revitLink as string} className='option'>
                    <Download />Revit-файлы
                  </a>
                  <a href={nanoCadLink as string} className='option'>
                    <Download />nanoCAD
                  </a>
                </div>
              )}
            </div>
          </div>
        </div>
        <div className='file-wrapper col-lg-3'>
          <div className="file-wrapper__file tech-docs">
            <File3 />
          </div>
          <div className="file-wrapper__title">
            <h3>Техническая информация</h3>
            <div className="title-select">
              <div className={isTechDocs ? 'select-arrow-open' : 'select-arrow-close'} onClick={() => setIsTechDocs(!isTechDocs)}>
                <Arrow />
              </div>
              {isTechDocs && (
                <div className='select-options'>
                  <Link to="/catalog" replace={false} className='option'>Каталог</Link>
                  <Link to="/certificates" className='option'>Сертификаты</Link>
                  <Link to="/flyers" className='option'>Листовки</Link>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
}

export default ToDesigners;
